<template>
  <div>
     <div :id="chart_id + '_bar'" class="morris-chart mt-4"></div>
  </div>
</template>
<script>
  import { Bar } from 'vue-chartjs';
  export default {
    extends: Bar,
    props: {
      chartdata: {
        type: Array,
        default: () => []
      },
      chart_id: {
        type: String,
        default: ""
      },
      bar_label: {
        type: String,
        default: ""
      },
      bar_color: {
        type: String,
        default: "#2196f3"
      },
    },
    data() {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              display: true,
              stacked: false,
              gridLines: {
                display: false
              }
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(0, 0, 0, 0.05)',
                drawBorder: true
              }
            }]
          }
        }
      }
    },
    mounted() {
      // this.addPlugin({
      //   beforeDraw: function (c) {
      //     var ctx = c.chart.ctx;
      //     ctx.fillStyle = "#FFF";
      //     ctx.fillRect(0, 0, c.chart.width, c.chart.height);
      //     ctx.save();
      //   }
      // })
      this.init()
      // this.renderChart(this.chartdata, this.options);
    },
    methods: {
      init(){
        this.createBarChart(this.chart_id + "_bar", this.chartdata, "label", ["total"], [this.bar_label], [this.bar_color]);
      },
      createBarChart(e, a, r, t, o, i){
        Morris.Bar({
          element: e,
          data: a,
          xkey: r,
          ykeys: t,
          labels: o,
          hideHover: "auto",
          resize: true,
          gridLineColor: "rgba(108, 120, 151, 0.1)",
          barSizeRatio: .8,
          barColors: i,
          xLabelMargin: 1
        })
      }

    }
  };
</script>
